/*
 * OLEA — Header behaviour.
 * - Toggles `.is-scrolled` on the header once the user passes the
 *   configured scroll threshold.
 * - Opens / closes the mobile menu overlay; locks body scroll while open;
 *   honors ESC + reduced-motion.
 *
 * No framework, no dependencies. Idempotent — runs at parse time
 * (header is rendered before this script's <script defer> tag).
 */
(function () {
  'use strict';

  const header = document.querySelector('olea-header');
  if (!header) return;

  const threshold = parseInt(header.dataset.scrollThreshold, 10) || 80;
  const overlay = document.getElementById('olea-header-overlay');
  const trigger = header.querySelector('.olea-header__menu-trigger');
  const closeBtn = overlay ? overlay.querySelector('.olea-header__overlay-close') : null;
  const overlayLinks = overlay ? overlay.querySelectorAll('.olea-header__overlay-link') : [];

  // ---------- Scroll state ----------
  let ticking = false;
  function syncScrollState() {
    if (window.scrollY > threshold) {
      header.classList.add('is-scrolled');
    } else {
      header.classList.remove('is-scrolled');
    }
    ticking = false;
  }
  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(syncScrollState);
      ticking = true;
    }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  syncScrollState();

  // ---------- Mobile overlay ----------
  if (overlay && trigger) {
    function openOverlay() {
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
      trigger.setAttribute('aria-expanded', 'true');
      document.documentElement.style.overflow = 'hidden';
      if (closeBtn) closeBtn.focus({ preventScroll: true });
    }
    function closeOverlay() {
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      trigger.setAttribute('aria-expanded', 'false');
      document.documentElement.style.overflow = '';
      trigger.focus({ preventScroll: true });
    }

    trigger.addEventListener('click', openOverlay);
    if (closeBtn) closeBtn.addEventListener('click', closeOverlay);

    // Close on link tap (mobile nav)
    overlayLinks.forEach(function (link) {
      link.addEventListener('click', closeOverlay);
    });

    // Close on ESC
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) {
        closeOverlay();
      }
    });
  }
})();
